import api from '../lib/axios';
import { downloadFile } from '../lib/download';
export async function getReports(params) {
    const { data } = await api.get('/api/admin/reports', { params });
    return data;
}
export async function getReport(id) {
    const { data } = await api.get(`/api/admin/reports/${id}`);
    return data.data;
}
export async function changeReportStatus(id, body) {
    const { data } = await api.patch(`/api/admin/reports/${id}/status`, body);
    return data.data;
}
export async function addReportNote(id, note) {
    const { data } = await api.post(`/api/admin/reports/${id}/note`, { admin_note: note });
    return data.data;
}
export async function changeReportCitizenResponse(id, citizenResponse) {
    const { data } = await api.patch(`/api/admin/reports/${id}/citizen-response`, { citizen_response: citizenResponse });
    return data.data;
}
export async function changeReportCategory(id, category) {
    const { data } = await api.patch(`/api/admin/reports/${id}/category`, { category });
    return data.data;
}
export async function getReportStats() {
    const { data } = await api.get('/api/admin/reports/stats');
    return data.data;
}
export function exportReportsCsv(params) {
    return downloadFile('/api/admin/reports/export/csv', `signalements_${new Date().toISOString().slice(0, 10)}.csv`, params);
}
